export default __webpack_public_path__ + "static/top_msquare_img-88903c8c2f7cb671ae0256be21cce722.jpg";